import { connect } from 'react-redux'
import ExamplesEntry from './examples-entry'
import { getExample } from '../../../../../../stores/examples/examples.selectors'
import { format } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const example = getExample(state, id)
  return {
    id: example.id,
    title: example.title,
    createdAt: format(example.created_at, 'DD.MM.YYYY'),
    link: `/assessment-files/${example.id}`,
    //conclusion: example.concluded,
    //student: example.student_type && example.student_type.account.full_name,
    thumb:
      example.works &&
      example.works[0] &&
      example.works[0].media &&
      example.works[0].media[0] &&
      example.works[0].media[0].thumb_url,
    author: example.teacher_type && example.teacher_type.full_name,
    ageGroupTitle:
      example.student_types &&
      example.student_types[0] &&
      example.student_types[0].year_group &&
      example.student_types[0].year_group.title,
    ageGroupOrder:
      example.student_types &&
      example.student_types[0] &&
      example.student_types[0].year_group &&
      example.student_types[0].year_group.order
  }
}

export default connect(
  mapStateToProps,
  null
)(ExamplesEntry)
